import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import WorkflowIcon from "../../../../../../assets/icons/Icon-Workflow-16px-Blue.svg";
import { NIL as NIL_UUID } from "uuid";
import { TriyoForm } from "../../../../../../components/TriyoForm";
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import PropTypes from "prop-types";
import { GetAllWorkflows } from "../../../../../../services/api/workflow-api";
import "./workflow.scss";

const Workflow = ({
  taskType,
  setTaskType,
  enableCustomizedWorkflow,
  setEnableCustomizedWorkflow,
}) => {
  const [activeWorkflows, setActiveWorkflows] = useState([]);

  useEffect(() => {
    const GetWorkflows = async () => {
      try {
        let response = await GetAllWorkflows();
        if (response.status === 200) {
          let result = response.data.filter((obj) => {
            if (obj.Id === taskType.WorkflowId && obj.Deleted) {
              return true;
            } else {
              return obj.Deleted === false;
            }
          });
          setActiveWorkflows(result);
        } else {
          console.log("Error [GetAllWorkflows] => ", response?.response?.data);
        }
      } catch (e) {
        console.log("Error [GetWorkflows] => ", e);
      }
    };
    GetWorkflows();
  }, []);

  return (
    <Form.Row className="form-row task-type-workflow">
      <div className="task-accordion-container task-reminders">
        <div className="heading">
          <div className="heading-description">
            <img
              className="heading-image"
              alt="Workflow Icon"
              src={WorkflowIcon}
            />
            <h4 className="heading-name">Enable Customized Workflow</h4>
          </div>
          <TriyoForm.Toggle
            id="custom-switch"
            checked={enableCustomizedWorkflow}
            onChange={(e) => {
              if (!enableCustomizedWorkflow) {
                setTaskType({ ...taskType, WorkflowId: taskType.WorkflowId });
              } else {
                setTaskType({ ...taskType, WorkflowId: NIL_UUID });
              }
              setEnableCustomizedWorkflow(!enableCustomizedWorkflow);
            }}
          />
        </div>
        <div className="workflow-subtext">
          Toggle to enable customized workflow. Turning the toggle off will
          apply the base task flow.
        </div>
        <div className="workflow-subtext">Customized Workflow:</div>
        <div className="workflow-dropdown">
          <DropdownMain
            values={activeWorkflows.map((wf) => {
              return {
                id: wf.Id,
                name: wf.Name + (wf.Deleted ? " - Archived" : ""),
              };
            })}
            dropdownButtonText={"Select a customized workflow"}
            onSelect={(selectedValue) => {
              setTaskType({ ...taskType, WorkflowId: selectedValue.id });
            }}
            currentSelected={
              taskType.WorkflowId == NIL_UUID
                ? null
                : { id: taskType.WorkflowId }
            }
            disabled={!enableCustomizedWorkflow}
          />
        </div>
      </div>
    </Form.Row>
  );
};

Workflow.propTypes = {
  taskType: PropTypes.shape({
    WorkflowId: PropTypes.string,
  }),
  setTaskType: PropTypes.func.isRequired,
  enableCustomizedWorkflow: PropTypes.bool.isRequired,
  setEnableCustomizedWorkflow: PropTypes.func.isRequired,
};

export default Workflow;
